// Product-domain helper functions for loon products and price formatting
import { BASELINE_PACK_SIZE, DEFAULT_PACK_PRESENTATION, PACK_PROFILES, } from '../configs/loonPacks';
const PACK_PRESENTATION_BY_LOONS = PACK_PROFILES.reduce((acc, profile) => {
    acc[profile.packSize] = profile.presentation;
    return acc;
}, {});
export const getProductLoonsGranted = (product) => {
    if (typeof product.loonsGranted === 'number' && product.loonsGranted > 0) {
        return product.loonsGranted;
    }
    const nameMatch = product.name.match(/(\d+)/);
    if (!nameMatch) {
        return null;
    }
    const parsedSize = Number(nameMatch[1]);
    return Number.isNaN(parsedSize) ? null : parsedSize;
};
export const sortProductsByLoonsGranted = (products) => [...products].sort((left, right) => {
    const leftLoons = getProductLoonsGranted(left);
    const rightLoons = getProductLoonsGranted(right);
    if (leftLoons === null && rightLoons === null) {
        return left.listPrice - right.listPrice;
    }
    if (leftLoons === null) {
        return 1;
    }
    if (rightLoons === null) {
        return -1;
    }
    if (leftLoons !== rightLoons) {
        return leftLoons - rightLoons;
    }
    return left.listPrice - right.listPrice;
});
export const getActiveLoonProducts = (products) => sortProductsByLoonsGranted(products.filter((product) => {
    const loonsGranted = getProductLoonsGranted(product);
    return (product.active && typeof loonsGranted === 'number' && loonsGranted > 0);
}));
export const getProductPresentation = (product) => {
    const loonsGranted = getProductLoonsGranted(product);
    if (!loonsGranted) {
        return DEFAULT_PACK_PRESENTATION;
    }
    return PACK_PRESENTATION_BY_LOONS[loonsGranted] || DEFAULT_PACK_PRESENTATION;
};
export const getDefaultLoonProduct = (products) => {
    if (products.length === 0) {
        return null;
    }
    const sortedProducts = sortProductsByLoonsGranted(products);
    const mostPopularProduct = sortedProducts.find((product) => getProductPresentation(product).pricingBadge === 'Most Popular');
    return mostPopularProduct || sortedProducts[0];
};
export const getExtraLoonsPercent = (product, baselinePricePerLoon) => {
    if (!baselinePricePerLoon || baselinePricePerLoon <= 0) {
        return null;
    }
    const loonsGranted = getProductLoonsGranted(product);
    if (!loonsGranted || loonsGranted <= BASELINE_PACK_SIZE) {
        return null;
    }
    const pricePerLoon = product.listPrice / loonsGranted;
    if (pricePerLoon <= 0) {
        return null;
    }
    const extraPercent = (baselinePricePerLoon / pricePerLoon - 1) * 100;
    return Math.max(0, Math.round(extraPercent));
};
export const getBaselinePricePerLoon = (products) => {
    const baselineProduct = products.find((product) => getProductLoonsGranted(product) === BASELINE_PACK_SIZE);
    if (!baselineProduct) {
        return null;
    }
    const loonsGranted = getProductLoonsGranted(baselineProduct);
    if (!loonsGranted || loonsGranted <= 0) {
        return null;
    }
    const pricePerLoon = baselineProduct.listPrice / loonsGranted;
    return pricePerLoon > 0 ? pricePerLoon : null;
};
export const formatProductPrice = (product) => {
    const priceInDollars = product.listPrice / 100;
    const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: product.currency,
        minimumFractionDigits: 2,
    }).format(priceInDollars);
    return {
        price: formattedPrice,
        interval: product.interval,
    };
};
//# sourceMappingURL=getProducts.js.map